var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import GridContainer from "@frameworks/web/components/generic/CommonUI/GridContainer";
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import React from "react";
import { Row, Col } from "react-bootstrap";
import DeviceContext from "@frameworks/shared-library/components/customHooks/indentifyDevice";
import ServiceGenericTab from "./ServiceGenericTab";
import config from "@frameworks/web/config/domain";
import { CommonCalendar } from "./CommonCalendar";
import moment from "moment";
export var navigateSelf = function (url) {
    window.open(url, "_self");
};
export var SRDateRange = React.createContext({
    startDate: new Date(),
    endDate: new Date(),
});
var ServiceRequest = function () {
    var device = DeviceContext();
    var _a = __read(React.useState(new Date(new Date(moment().format()))), 2), endDate = _a[0], setEndDate = _a[1];
    var _b = __read(React.useState(new Date(moment().subtract(7, "days").format())), 2), startDate = _b[0], setStartDate = _b[1];
    return (React.createElement(SRDateRange.Provider, { value: { startDate: startDate, endDate: endDate } }, device && (React.createElement(GridContainer, { parentClass: (device === null || device === void 0 ? void 0 : device.isDesktop)
            ? "px-0 mgt-50 mb-50 service-request-desktop"
            : "mgt-30 mb-30 service-request-mobile" },
        React.createElement(Row, { className: "mx-0" },
            React.createElement(Col, { lg: 12, className: "d-space-between px-0" },
                (device === null || device === void 0 ? void 0 : device.isDesktop) ? (React.createElement("span", { className: "DMSan_28_400" },
                    React.createElement("strong", null, "Service"),
                    " Requests")) : (React.createElement("span", { className: "DMSansMedium_20_500" },
                    React.createElement("strong", null, "Service"),
                    " Requests")),
                React.createElement("span", null, (device === null || device === void 0 ? void 0 : device.isDesktop) ? (React.createElement(EdButton, { value: "Create Service Request", className: "sr-button-ed", btnTyp: "midnight-blue", onClick: function () {
                        navigateSelf(config.serviceRequest_base +
                            config.sr_web +
                            "service-request/open?source=onep-sr");
                    } })) : (React.createElement("div", { className: "newticket-btn px-3 ", onClick: function () {
                        navigateSelf(config.serviceRequest_base +
                            config.sr_web +
                            "service-request/open?source=onep-sr");
                    } },
                    React.createElement("span", { className: "edel-icon-rounded-plus" }),
                    React.createElement("span", { className: "ps-2 DMSan_14_500" }, "Create"))))),
            React.createElement(Col, { lg: 12, className: "px-0 mgt-10 mb-10" },
                React.createElement(CommonCalendar, { setStartDate: setStartDate, setEndDate: setEndDate, startDate: startDate, endDate: endDate })),
            React.createElement(Col, { lg: 12, className: (device === null || device === void 0 ? void 0 : device.isDesktop)
                    ? "px-0"
                    : "px-0 common-filter-sorting-ui small-height-50 font-normal" },
                React.createElement(ServiceGenericTab, null)))))));
};
export default ServiceRequest;
